import React from "react";
import { Dropdown } from "react-bootstrap";
import FormInput from "./FormInput";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </a>
));

const CustomMenu = React.forwardRef(
  ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <ul className="list-unstyled">
          {React.Children.toArray(children).filter(
            (child) => child.type !== "input"
          )}
        </ul>
      </div>
    );
  }
);

const TableColumnDropdownCheck = ({
  options,
  selectedOptions,
  onSelectionChange,
}) => {
  const [checkedItems, setCheckedItems] = React.useState(
    options.reduce((acc, option) => {
      acc[option] = true;
      return acc;
    }, {})
  );

  const handleCheckboxChange = (option) => {
    const newCheckedItems = {
      ...checkedItems,
      [option]: !checkedItems[option],
    };
    setCheckedItems(newCheckedItems);

    onSelectionChange(
      Object.keys(newCheckedItems).filter((key) => newCheckedItems[key])
    );
  };

  React.useEffect(() => {
    onSelectionChange(options);
  }, []);

  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
        All Columns
      </Dropdown.Toggle>

      <Dropdown.Menu as={CustomMenu} style={{ width: "275px", background:'#ffffff' }}>
        {options.map((option) => (
          <Dropdown.Item
            key={option}
            onClick={(e) => e.stopPropagation()}
            style={{ display: "flex", gap: "15px" }}
          >
            <FormInput
              type="checkbox"
              checked={checkedItems[option]}
              onChange={() => handleCheckboxChange(option)}
            />{" "}
            {option}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default TableColumnDropdownCheck;
